<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M2.98047 4.16211C5.72918 1.33503 10.2699 1.335 13.0186 4.16211L14.7168 5.90918C15.8484 7.07357 15.8487 8.92757 14.7168 10.0918L13.0186 11.8379C10.2698 14.6651 5.7292 14.6651 2.98047 11.8379L1.28223 10.0918C0.150324 8.92755 0.150558 7.07357 1.28223 5.90918L2.98047 4.16211ZM8 5.75C6.75737 5.75 5.75002 6.75738 5.75 8C5.75 9.24264 6.75736 10.25 8 10.25C9.24242 10.2497 10.25 9.24248 10.25 8C10.25 6.75754 9.2424 5.75026 8 5.75Z"
    fill="currentColor"
  />
</svg>
